import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Requested amount: ")
const _hoisted_2 = { class: "font-semibold" }
const _hoisted_3 = { class: "my-2" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Method: ")
const _hoisted_5 = { class: "font-semibold" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Email: ")
const _hoisted_7 = { class: "font-semibold" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "Note", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Approve")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: "Approve",
    width: "480",
    top: "30vh"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.submit
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, [
        _hoisted_1,
        _createElementVNode("span", _hoisted_2, "$" + _toDisplayString(_ctx.data.amount), 1)
      ]),
      _createElementVNode("p", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.methodName(_ctx.data.payoutMethod.paymentType)), 1)
      ]),
      _createElementVNode("p", null, [
        _hoisted_6,
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.data.payoutMethod.paymentValue), 1)
      ]),
      _hoisted_8,
      _createVNode(_component_el_input, {
        modelValue: _ctx.note,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.note) = $event)),
        autosize: { minRows: 2, maxRows: 4 },
        type: "textarea"
      }, null, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}